// extracted by mini-css-extract-plugin
export var bannerContainer = "NewMobileBanner_bannerContainer__JMYAp";
export var buttonContainer = "NewMobileBanner_buttonContainer__JYft8";
export var closeNewMobileBannerText = "NewMobileBanner_closeNewMobileBannerText__S7WPW";
export var container = "NewMobileBanner_container__tfgPJ";
export var description = "NewMobileBanner_description__nu15p";
export var headerContainer = "NewMobileBanner_headerContainer__EntJB";
export var logoImage = "NewMobileBanner_logoImage__krmGf";
export var mobileImageContainer = "NewMobileBanner_mobileImageContainer__Er1O3";
export var openButton = "NewMobileBanner_openButton__ijK+K";
export var textContainer = "NewMobileBanner_textContainer__gtbGw";
export var title = "NewMobileBanner_title__Iv7Vq";